import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "labcolor"
    }}>{`LabColor`}</h1>
    <p>{`Defines a L`}<sup>{`*`}</sup>{`a`}<sup>{`*`}</sup>{`b`}<sup>{`*`}</sup>{` color, used in `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/solidcolor/"
      }}>{`SolidColor`}</a>{` object.`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`a`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The a-value.  `}<strong parentName="td">{`\``}{`default`}{`\``}</strong>{` 0  `}<strong parentName="td">{`\``}{`range`}{`\``}</strong>{` -128..127`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`b`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The b-value.  `}<strong parentName="td">{`\``}{`default`}{`\``}</strong>{` 0  `}<strong parentName="td">{`\``}{`range`}{`\``}</strong>{` -128..127`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`l`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The L-value.  `}<strong parentName="td">{`\``}{`default`}{`\``}</strong>{` 100  `}<strong parentName="td">{`\``}{`range`}{`\``}</strong>{` 0..100`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      